// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-be327b02] .v-data-table-header th .v-data-table-header__icon{color:#fff!important}[data-v-be327b02] .v-pagination{justify-content:start!important}.pagination-column ul[data-v-be327b02]{width:auto}.tbl-row--deleted[data-v-be327b02]{opacity:.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
